export default __webpack_public_path__ + "static/media/code2.c8f6be90.png";